// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__24eed","errorLogs":"EditorFooter_errorLogs__4mQW3"};